import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  Typography,
  AccordionSummary,
} from "@mui/material";
import { MaterialSymbol } from "@datalake/towercontrol-banner";
export default function Order(props) {
  const orderDetails = props?.orderDetails;

  return (
    <React.Fragment>
      <div style={{ width: "100%" }}>
        <TableContainer component={Paper}>
          <Accordion defaultExpanded={true}>
            <AccordionSummary
              expandIcon={<MaterialSymbol name="expand_more" />}
            >
              <Typography
                style={{
                  width: "100%",
                }}
              >
                <MaterialSymbol
                  name="receipt"
                  style={{ marginRight: "1%", verticalAlign: "middle" }}
                />
                Order
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Table
                sx={{ minWidth: "30%" }}
                size="small"
                aria-label="serial number reference table"
              >
                <TableBody>
                  {orderDetails.map((row, i) => {
                    return (
                      <TableRow key={row.name + i + "row"}>
                        <TableCell key={row.name + i + " namecell"}>
                          {row.name}
                        </TableCell>
                        <TableCell key={row.value + i + " valuecell"}>
                          {row.value}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>
        </TableContainer>
      </div>
    </React.Fragment>
  );
}
